'use strict';

export default function () {
    return {
        restrict: 'A',
        template: require('../../dashboard/view/dashboard-info.html'),
        controller: [
            '$scope',
            ($scope) => {

                function getValueOrAll(value) {
                    return value ? { ...value } : { name: 'Все' };
                }
                $scope.current = {
                    milestone: { name: 'Все'},
                    industry: { name: 'Все'},
                    area: { name: 'Все'},
                    phase: { name: 'Все'},
                    fundsTotal: { name: 'Все'},
                    workplaces: { name: 'Все'},
                }
                const defaultDescriptors = {
                    writable: true,
                    configurable: true,
                    enumerable: false,
                    value: 'Все',
                }
                Object.defineProperties($scope.current, {
                    placeMunicipality: defaultDescriptors,
                    industry: defaultDescriptors,
                    phase: defaultDescriptors,

                })
                $scope.current.milestone =  $scope.milestones.find(item => item.id === $scope.filters.milestone);
                $scope.current.industry = $scope.filters.industry.length ?
                    $scope.filters.industry.map(item => item.name) :
                    ['Все'];
                $scope.current.area = $scope.localFilters.area;
                $scope.current.phase = $scope.localFilters.phase.length ?
                    $scope.localFilters.phase.map(item => item.name) :
                    ['Все'];
                $scope.current.placeMunicipality = $scope.localFilters.placeMunicipality.length ?
                    $scope.localFilters.placeMunicipality.map(item => item.name) :
                    ['Все'];
                $scope.current.fundsTotal.name = 'Все';
                if ($scope.localFilters.planFundsTotal1 != null) {
                    let name = $scope.getOperatorDisplayName($scope.localFilters.operatorPlanFundsTotal);
                    if ($scope.isBetween($scope.localFilters.operatorPlanFundsTotal)) {
                        name += ` ${$scope.localFilters.planFundsTotal1}`;
                        if ($scope.localFilters.planFundsTotal2 != null) {
                            name += ` и ${$scope.localFilters.planFundsTotal2}`;
                        }
                    } else {
                        name += ` ${$scope.localFilters.planFundsTotal1}`;
                    }
                    $scope.current.fundsTotal.name = `${name} млн руб.`;
                }
                $scope.current.workplaces.name = 'Все';
                if ($scope.localFilters.profitPlanWplaces1 != null) {
                    let name = $scope.getOperatorDisplayName($scope.localFilters.operatorPlanFundsTotal);
                    if ($scope.isBetween($scope.localFilters.operatorProfitPlanWplaces)) {
                        name += ` ${$scope.localFilters.profitPlanWplaces1}`;
                        if ($scope.localFilters.profitPlanWplaces2 != null) {
                            name += ` и ${$scope.localFilters.profitPlanWplaces2}`;
                        }
                    } else {
                        name += ` ${$scope.localFilters.profitPlanWplaces1}`;
                    }
                    $scope.current.workplaces.name = name;
                }
                for (let key in $scope.current) {
                    $scope.current[key] = getValueOrAll($scope.current[key]);
                    $scope.current[key].name = $scope.current[key].name.replace(/<|>/g,'');
                }
            }
        ]
    }
}